const CONVERSATIONS_PER_PAGE = 10;

export { CONVERSATIONS_PER_PAGE };
